// Resume Video Url ***********************************************************************************
// pathname: /v1/resume-operation/{userId}/video-url
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';
import { ApiPathParams } from '@type/api/apiUtilityFn';

interface SwrResumeVideoUrlProps extends ApiPathParams<'/v1/resume-operation/{userId}/video-url', 'get'> {
  locale?: Locale;
  shouldFetch?: boolean;
}

/**
 * @description SWR: fetch user video cv.
 * @param locale - { string } - the locale to use for the request. Default: 'ro'.
 * @param shouldFetch - { boolean } - a flag indicating whether to start fetching. Default: true
 * @param userId - { string } - the user id to get the video cv for.
 */
export const useSwrResumeVideoUrl = (props: SwrResumeVideoUrlProps) => {
  // Destructure props
  const {
    locale = 'ro',
    shouldFetch = true,
    userId,
  } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<string>({
    url: `/v1/resume-operation/${userId}/video-url`,
    shouldFetch,
    locale,
    apiOptions: {
      dedupingInterval: 10 * 1000, // 10 seconds
      revalidateOnFocus: false,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
